module.exports = __webpack_public_path__ + "elit vizyon banyo 2.jpg?1994e08f49ae8842b7381dc88b4b5d8e";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/elit vizyon banyo 2.jpg
// module id = 347
// module chunks = 0